exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-static[data-v-6a5d4376]{font-size:16px;line-height:1.6;font-weight:400}.a-static table[data-v-6a5d4376]{width:100%;margin:var(--spacer-2xl) 0;border-collapse:collapse}.a-static table th[data-v-6a5d4376],.a-static table td[data-v-6a5d4376]{padding:calc(var(--spacer-sm) * 2);border:1px solid var(--_c-light-primary-darken)}.a-static .content[data-v-6a5d4376]{padding:var(--spacer-sm)}\n", ""]);

// exports
